import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-468882f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistics" }
const _hoisted_2 = { class: "statistics-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "line-chart-wrapper"
}

import { ref, onMounted } from "vue";
import * as echarts from "echarts";
import { getPrototypeStatistics } from "@/request/view/prototypeManagement";
import { customerType } from "./options";
import countUseLine from "./componemt/countUseLine.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics',
  setup(__props) {

const barChart = ref();
const pieChart = ref();

const barOption = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  legend: {},
  title: {
    text: "渠道产品使用次数柱状图",
    left: "center",
    top: "10px",
  },
  grid: { left: "50px", right: "50px", top: "60px", bottom: "30px" },
  xAxis: [
    {
      type: "category",
      data: [],
      name: "类型",
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "次",
      boundaryGap: ['0%', '5%'],
      axisLine: {
        show: true,
        symbol: ["none", "arrow"],
        symbolOffset: 8,
        symbolSize: 10,
      },
      axisTick: {
        show: true,
      },
    },
  ],
  series: [],
};

const pieOption = {
  tooltip: {
    trigger: "item",
    formatter: "{b}: {d}%",
  },
  title: {
    text: "渠道产品使用占比饼图",
    left: "10px",
    top: "10px",
  },
  series: [],
};

const series = [
  {
    data: [],
    type: "bar",
    showBackground: true,
    barMaxWidth: 60,
    backgroundStyle: {
      color: "rgba(180, 180, 180, 0.2)",
    },
    label: {
      show: true,
      fontSize: 16,
    },
  },
  {
    type: "pie",
    data: [],
    radius: "70%",
    label: {
      show: true,
      formatter: (params) => {
        const { data, percent, name } = params;
        const text = data.value ? `${name}\n${percent}%` : '';
        return text;
      },
      fontSize: '16'
    },
  },
];

const xAxisData = [];

const statisticsData = ref(null);

const getStatistics = () => {
  getPrototypeStatistics().then((res) => {
    if (res.code === 200) {
      statisticsData.value = res.data;
      Object.keys(res.data).forEach((key) => {
        const data = res.data[key];
        let count = 0;
        Object.keys(data).forEach((key) => {
          count += data[key];
        });
        xAxisData.push(key);
        series[0].data.push(count);
        series[1].data.push({ value: count, name: key });
      });

      barOption.series = series.filter((f) => f.type === "bar");
      barOption.xAxis[0].data = xAxisData;

      pieOption.series = series.filter((f) => f.type === "pie");
      barOption.xAxis[0].data = xAxisData;

      const bChart = echarts.init(barChart.value);
      bChart.setOption(barOption);

      const pChart = echarts.init(pieChart.value);
      pChart.setOption(pieOption);
    }
  });
};

onMounted(() => {
  getStatistics();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "bar-chart card-wrapper",
        ref_key: "barChart",
        ref: barChart
      }, null, 512),
      _createElementVNode("div", {
        class: "pie-chart card-wrapper",
        ref_key: "pieChart",
        ref: pieChart
      }, null, 512)
    ]),
    (statisticsData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statisticsData.value, (data, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
              data
                ? (_openBlock(), _createBlock(countUseLine, {
                    key: 0,
                    data: data,
                    name: key
                  }, null, 8, ["data", "name"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})